import {MD3LightTheme as DefaultTheme} from 'react-native-paper';
import CustomColors from './Colors'

// const fontConfig = {
//     ios: {
//         regular: {
//             fontFamily: 'Sora-Regular',
//             fontWeight: '400'
//         },
//         medium: {
//             fontFamily: 'Sora-Medium',
//             fontWeight: '500',
//         },
//         light: {
//             fontFamily: 'Sora-Light',
//             fontWeight: '300',
//         },
//         thin: {
//             fontFamily: 'Sora-Thin',
//             fontWeight: '100',
//         },
//     },
//     android: {
//         regular: {
//             fontFamily: 'Sora-Regular',
//             fontWeight: '400',
//         },
//         medium: {
//             fontFamily: 'Sora-Medium',
//             fontWeight: '500',
//         },
//         light: {
//             fontFamily: 'Sora-Light',
//             fontWeight: '300',
//         },
//         thin: {
//             fontFamily: 'Sora-Thin',
//             fontWeight: '100',
//         },
//     }
// }

const theme = {
    ...DefaultTheme,
    //fonts: configureFonts({ config: fontConfig, isV3: true }),
    myOwnProperty: true,
    colors: {
        ...DefaultTheme.colors,
        ...CustomColors,
    },
};

export default theme
